export default __webpack_public_path__ + "static/media/logo.5fceb9e7.png";